export default __webpack_public_path__ + "static/media/xtime-spectrum-300px.77442d65.png";